import { render, staticRenderFns } from "./Tab6.vue?vue&type=template&id=5dc05e5c&"
import script from "./Tab6.vue?vue&type=script&lang=js&"
export * from "./Tab6.vue?vue&type=script&lang=js&"
import style0 from "./Tab6.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports